import { CanDeactivateFn } from '@angular/router';

/** Page qui peut contenir une saisie ou un traitement non terminé. */
export interface AvecSaisieEnCours {
  /** Vrai s'il reste du travail qui serait perdu en quittant la page. */
  aDuTravailNonEnregistre(): boolean;
  /** Message affiché dans la demande de confirmation. */
  messageQuitter?(): string;
}

/**
 * Demande confirmation avant de quitter une page dont le travail serait perdu
 * (navigation dans l'application). Le rechargement et la fermeture de l'onglet
 * sont couverts par l'écoute de `beforeunload` dans la page elle-même.
 */
export const unsavedChangesGuard: CanDeactivateFn<AvecSaisieEnCours> = component =>
  !component?.aDuTravailNonEnregistre()
  || window.confirm(component.messageQuitter?.() ?? 'Des modifications ne sont pas enregistrées. Quitter la page quand même ?');
